<template>
  <!-- 底栏 -->
  <div class="foot">
    <!-- 盒子 -->
    <div class="footBox">
      <!-- 左侧内容 -->
      <div class="footBoxL">
        <!-- 内容1 了解聚学云-->
        <div class="footBoxLs">
          <p class="pa">了解聚学云</p>
          <p class="pb" @click="about">聚学云介绍</p>
          <p class="pb" @click="contact">加入我们</p>
          <p class="pb" @click="detail">企业动态</p>
        </div>
        <!-- 内容2 友情链接-->
        <div class="footBoxLs">
          <p class="pa">友情链接</p>
          <p class="pb" @click="weixin">微信小程序</p>
          <p class="pb">报读推广</p>
          <p class="pb" @click="xlcjy">新里程教育</p>
        </div>
        <!-- 内容3 联系我们-->
        <div class="footBoxLs">
          <p class="pa">联系我们</p>
          <p class="pb" @click="hzqt">合作洽谈</p>
          <p class="pb">售前咨询</p>
          <p class="pb">售后咨询</p>
        </div>
        <!-- 内容4 400-123-1234-->
        <div class="footBoxLs">
          <p class="pc">400-6632-666</p>
          <div>
            <img src="@/assets/img/home/icon (11).png" alt="" style="width: 14px; height: 14px" /><span
              >周一至周日 9:30-18:00</span
            >
          </div>
          <div>
            <img src="@/assets/img/home/icon (12).png" alt="" style="width: 14px; height: 11px" /><span
              >613308970@qq.com</span
            >
          </div>
          <div>
            <img src="@/assets/img/home/dz(1).png" alt="" style="width: 11px; height: 14px" /><span
              >山东省济南市历下区海信贤文中心2号楼4层</span
            >
          </div>
        </div>
      </div>
      <!-- 右侧内容 -->
      <div class="footBoxR">
        <!-- 内容1 咨询微信-->
        <div class="footBoxRs">
          <img src="@/assets/1123.jpg" alt="" />
          <p>咨询微信</p>
        </div>
        <!-- 内容2 小程序 -->
      </div>
    </div>
    <p>
      版权所有：聚学云科技集团有限公司 All Rights Reserved .版权所有<br />
      <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备09085022号</a><br />
      <a href="https://www.beian.gov.cn" target="_blank">鲁公安备 37010102001067号 </a>
    </p>
    <div class="beian">
      <a
        href="https://xyt.xcc.cn/getpcInfo?sn=1475344335598010368&language=CN&certType=8&url=*.juxueyun.com"
        target="_blank"
        style="position: relative"
      >
        <div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"></div>
        <embed
          src="https://program.xinchacha.com/web/1475344335598010368=*.juxueyun.com.svg"
          width="103"
          height="38"
          type="image/svg+xml"
          pluginspage="//www.adobe.com/svg/viewer/install/"
      /></a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    // 聚学云介绍
    about() {
      // console.log("333333333333333333333333333333333");
      this.$router.push({ path: '/aboutIntroduce?inde=0' })
    },
    // 加入我们
    contact() {
      this.$router.push({ path: '/aboutJoin?inde=1' })
    },
    // 资讯中心查看更多按钮
    detail() {
      // 跳转资讯中心页面（全内容）
      this.$router.push({ path: '/aboutNew?inde=2' })
    },
    weixin() {
      window.location.href = 'https://open.weixin.qq.com/'
      // window.open()
    },
    xlcjy() {
      window.location.href = 'http://xlcxx.com'
      // window.open()
    },
    hzqt() {
      this.$router.push({ path: '/cooperation' })
    },
  },
}
</script>
<style lang="less" scoped>
// 底栏
.foot {
  width: 100%;
  height: 351px;
  background: #030917;
  opacity: 1;
  overflow: hidden;
  // 盒子
  .footBox {
    width: auto;
    margin: 40px 360px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    // 左侧内容
    .footBoxL {
      width: 940px;
      height: auto;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      // 单个内容
      .footBoxLs {
        width: auto;
        // height: auto;
        margin-right: 50px;
        .pa {
          width: 100%;
          height: 24px;
          margin-bottom: 40px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #f5e8e8;
          // letter-spacing: 20px;
          opacity: 1;
          cursor: pointer;
        }
        .pb {
          width: 100%;
          height: 19px;
          margin-top: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          // letter-spacing: 20px;
          opacity: 1;
          cursor: pointer;
        }
        .pc {
          width: 100%;
          height: 40px;
          margin-bottom: 24px;
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          // letter-spacing: 20px;
          opacity: 1;
        }
        div {
          width: auto;
          height: 19px;
          margin-top: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            margin-right: 10px;
          }
          span {
            width: auto;
            height: auto;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            // letter-spacing: 20px;
            opacity: 1;
          }
        }
      }
    }
    // 右侧内容
    .footBoxR {
      width: 260px;
      height: auto;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      // 单个内容
      .footBoxRs {
        width: 120px;
        height: auto;
        img {
          width: 120px;
          height: 120px;
        }
        p {
          width: 100%;
          text-align: center;
          height: 19px;
          margin-top: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          // letter-spacing: 20px;
          opacity: 1;
        }
      }
    }
  }
  p {
    width: 100%;
    height: 40px;
    margin: 0px auto;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    // letter-spacing: 20px;
    opacity: 1;
    a {
      color: #999999;
    }
  }
}
.beian {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
</style>
